import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";
import { clx } from "../../../utils/Helpers";
import { getUserInitials } from "../../../utils/userInitials";
import "./_UIAvatar.scss";

const UIAvatar = ({
  alt = "",
  className = "",
  image,
  initials,
  maxInitials = 2,
  name = "",
  size = "md",
  src,
  variant = "brand",
  ...props
}) => {
  const imageSrc = src || image;
  const avatarInitials = initials || getUserInitials(name, maxInitials);

  return (
    <Avatar
      alt={alt || name}
      className={clx(
        "ui-avatar",
        `ui-avatar--${size}`,
        `ui-avatar--${variant}`,
        className
      )}
      src={imageSrc || undefined}
      {...props}
    >
      {!imageSrc ? avatarInitials : null}
    </Avatar>
  );
};

UIAvatar.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string,
  initials: PropTypes.string,
  maxInitials: PropTypes.number,
  name: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  src: PropTypes.string,
  variant: PropTypes.oneOf(["brand", "muted"]),
};

UIAvatar.defaultProps = {
  alt: "",
  className: "",
  image: undefined,
  initials: "",
  maxInitials: 2,
  name: "",
  size: "md",
  src: undefined,
  variant: "brand",
};

export default UIAvatar;
